import { NestedCheckboxGroup } from '../../NestedCheckboxGroup/NestedCheckboxGroup'
import { FlatCheckboxGroup } from '../../FlatCheckboxGroup/FlatCheckboxGroup'

import { CheckboxFilterDropdownContentProps } from '../types'

export const CheckboxFilterDropdownContent = (
    props: CheckboxFilterDropdownContentProps
) => {
    if (
        props.options?.every((option) => typeof option.value === 'string') &&
        props.value.every((val) => typeof val === 'string')
    ) {
        // Check if any option has children to determine if this is a nested structure
        const hasNestedChildren = props.options.some(
            (option) =>
                'children' in option &&
                Array.isArray(option.children) &&
                option.children.length > 0
        )

        if (hasNestedChildren) {
            return (
                <NestedCheckboxGroup
                    options={props.options}
                    checkedItems={props.value}
                    onChange={props.onChange}
                    itemWrapperClassname="overflow-hidden py-2 px-4"
                    wrapperClassname="space-y-1"
                    renderLabel={props.renderLabel}
                    toggleWrapperClassname="pr-3"
                />
            )
        }

        return (
            <FlatCheckboxGroup
                options={props.options}
                checkedItems={props.value}
                onChange={props.onChange}
                itemWrapperClassname="overflow-hidden py-2 px-4"
                wrapperClassname="space-y-1"
                renderLabel={props.renderLabel}
            />
        )
    }
}
